import { DateText } from "@portal/BaseComponents/Date/DateText";
import { Flex } from "@portal/BaseComponents/Flex/Flex";
import { TypographyTextProps } from "@portal/BaseComponents/Typography/type";

interface DateCellProps {
  value?: string;
  extra?: JSX.Element;
  textProps?: TypographyTextProps;
  wrapperStyle?: React.CSSProperties;
}

function DateCell(props: DateCellProps) {
  const { value, extra, textProps, wrapperStyle } = props;

  const Date = value ? <DateText value={value} textProps={textProps} /> : "-";
  return (
    <Flex
      justify="center"
      style={{ height: "100%", ...wrapperStyle }}
      align="center"
    >
      {Date}
      {extra}
    </Flex>
  );
}

export { DateCell };
